<div class="viewport-1" id="task-select" tabindex="0" (keyup)="autoCompleteTask($event)" [style.background-image]="'url(' + taskSelectBackgroundImage + ')'">
  <student-header #studentHeader></student-header>
  <side-menu #sideMenu (selectedAvatar)="updateSelectedAvatar($event)" [disabled]="disableSideButton"></side-menu>

  @if (!shouldDisplayAlternatingTasks) {
    <div class="task-select-content-div">
      <div class="task-wrapper">
        @for (taskButton of taskButtonList1 ; track taskButton.index ; let idx = $index) {
          <div [ngClass]="[ taskButton!.divContainer ]" [hidden]="!taskButton!.visible">
            <wf-task-select-button
              [position]="1"
              [idx]="idx"
              [taskSelect]="taskButton"
              [initializing]="disableButtons"
              [compareScores]="shouldCompareStudentScores"
              [alternating]="true"
              [isPreDiagnosticStudent]="isPreDiagnosticStudent"
              (onTaskSelectClick)="goToTask($event)"
              (onTaskSelectTouchStart)="highlightTaskButton($event.position, $event.idx)"
              (onTaskSelectTouchEnd)="handleTouchEnd($event.position, $event.idx,  $event.taskIdx, $event.$event)"
              (onTaskMouseOver)="highlightTaskButton($event.position, $event.idx)"
              (onTaskMouseLeave)="unhighlightTaskButton($event.position, $event.idx)" />
          </div>
        }
      </div>
      <div class="task-wrapper">
        @for (taskButton of taskButtonList2 ; track taskButton.index ; let idx = $index) {
          <div [ngClass]="[ taskButton!.divContainer ]" [hidden]="!taskButton!.visible">
            <wf-task-select-button
              [position]="2"
              [idx]="idx"
              [taskSelect]="taskButton"
              [initializing]="disableButtons"
              [compareScores]="shouldCompareStudentScores"
              [alternating]="true"
              [isPreDiagnosticStudent]="isPreDiagnosticStudent"
              (onTaskSelectClick)="goToTask($event)"
              (onTaskSelectTouchStart)="highlightTaskButton($event.position, $event.idx)"
              (onTaskSelectTouchEnd)="handleTouchEnd($event.position, $event.idx,  $event.taskIdx, $event.$event)"
              (onTaskMouseOver)="highlightTaskButton($event.position, $event.idx)"
              (onTaskMouseLeave)="unhighlightTaskButton($event.position, $event.idx)" />
          </div>
        }
      </div>
      <div class="task-wrapper">
        @for (taskButton of taskButtonList3 ; track taskButton.index ; let idx = $index) {
          <div [ngClass]="[ taskButton!.divContainer ]" [hidden]="!taskButton!.visible">
            <wf-task-select-button
              [position]="3"
              [idx]="idx"
              [taskSelect]="taskButton"
              [initializing]="disableButtons"
              [compareScores]="shouldCompareStudentScores"
              [alternating]="true"
              [isPreDiagnosticStudent]="isPreDiagnosticStudent"
              (onTaskSelectClick)="goToTask($event)"
              (onTaskSelectTouchStart)="highlightTaskButton($event.position, $event.idx)"
              (onTaskSelectTouchEnd)="handleTouchEnd($event.position, $event.idx,  $event.taskIdx, $event.$event)"
              (onTaskMouseOver)="highlightTaskButton($event.position, $event.idx)"
              (onTaskMouseLeave)="unhighlightTaskButton($event.position, $event.idx)" />
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="pre-diagnostic-task-select-content-div">
      @for (taskButton of taskButtonList ; track taskButton.index ; let idx = $index) {
        <div class="pre-task-wrapper">
          <div [ngClass]="[ taskButton!.divContainer ]" [hidden]="!taskButton!.visible">
            <wf-task-select-button
              [position]="0"
              [idx]="idx"
              [taskSelect]="taskButton"
              [initializing]="disableButtons"
              [compareScores]="shouldCompareStudentScores"
              [alternating]="false"
              [isPreDiagnosticStudent]="isPreDiagnosticStudent"
              (onTaskSelectClick)="goToTask($event)"
              (onTaskSelectTouchStart)="highlightTaskButton($event.position, $event.idx)"
              (onTaskSelectTouchEnd)="handleTouchEnd($event.position, $event.idx,  $event.taskIdx, $event.$event)"
              (onTaskMouseOver)="highlightTaskButton($event.position, $event.idx)"
              (onTaskMouseLeave)="unhighlightTaskButton($event.position, $event.idx)" />
          </div>
        </div>
      }
    </div>
  }
  <student-footer #studentFooter timerBackgroundImage="/assets/images/timer/timerLabel-task.svg"></student-footer>
  <focus-dialog></focus-dialog>
</div>
